import React, { useState } from 'react';
import api from '../api/api';
import { useFormik } from 'formik';
import * as yup from "yup";
import { useNavigate, useParams } from 'react-router-dom';
import TabTitle from '../components/TabTitle';
import { EyeFill, EyeSlashFill } from 'react-bootstrap-icons';

const ResetPassword = () => {
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const { vhash } = useParams();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const passwordValidationSchema = yup.object({
    password: yup
      .string("Enter your password")
      .min(8, "Password should be of minimum 8 characters length")
      .max(128, "Password should be of maximum 128 characters length")
      .required("Password is required"),
    confirmPassword: yup
      .string("Confirm your password")
      .oneOf([yup.ref('password'), null], 'Passwords must match')
      .required("Confirm password is required"),
  });

  const resetPasswordFormik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: passwordValidationSchema,
    onSubmit: async (values) => {
      const { password, confirmPassword } = values;
      setMessage('');
      setError('');
      setIsSubmitting(true);

      try {
        const response = await api.put('/assessment/forget_password/', { vhash, password, confirm_password: confirmPassword });
        const data = await response.data;

        if (response.status === 200) {
          setMessage('Your password has been successfully reset. You can now log in.');
          setTimeout(() => {
            navigate('/admin/login');
          }, 2000);
        } else {
          setError(data.message || 'Something went wrong. Please try again.');
        }
      } catch (err) {
        setError(err.response?.data?.message || 'Network error. Please try again later.');
      } finally {
        setIsSubmitting(false);
      }
    },
  });

  return (
    <div>
      <TabTitle title="Reset Password" />
      <div className="d-flex justify-content-center align-items-center full-height-background">
        <div className="col-10 p-sm-8 col-md-5 col-lg-5 col-xl-4" style={{ opacity: "0.85" }}>
          <div className="card p-4 p-md-5 p-sm-3 my-4">
            {message && <div className="mt-3 alert alert-info">{message}</div>}
            {error && <div className="mt-3 alert alert-danger">{error}</div>}

            <form onSubmit={resetPasswordFormik.handleSubmit} className='login-form'>
              <h2 className='mb-4 text-center fw-bold'>Reset Password</h2>
              <p className="text-center">Please enter your new password.</p>

              <div className="mb-4">
                <label htmlFor="password" className="form-label">New Password<span className="text-danger">*</span></label>
                <div className="input-group">
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control forminput-custom"
                  id="password"
                  name="password"
                  value={resetPasswordFormik.values.password}
                  onChange={resetPasswordFormik.handleChange}
                  onBlur={resetPasswordFormik.handleBlur}
                  required
                  minLength="8"
                  maxLength="128"
                />
                <button
                  className="btn btn-outline-secondary"
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{ width: '50px', height: '38px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                >
                  {showPassword ? (
                    <EyeFill color="#000" />
                  ) : (
                    <EyeSlashFill color="#000" />
                  )}
                </button>
                </div>
                {resetPasswordFormik.touched.password && resetPasswordFormik.errors.password && (
                  <small id="passwordHelpBlock" className="form-text text-danger">
                    {resetPasswordFormik.errors.password}
                  </small>
                )}
              </div>
              <div className="mb-4">
                <label htmlFor="confirmPassword" className="form-label">Confirm New Password<span className="text-danger">*</span></label>
                <div className="input-group">
                <input
                 type={showConfirmPassword ? "text" : "password"}
                  className="form-control forminput-custom"
                  id="confirmPassword"
                  name="confirmPassword"
                  value={resetPasswordFormik.values.confirmPassword}
                  onChange={resetPasswordFormik.handleChange}
                  onBlur={resetPasswordFormik.handleBlur}
                  required
                  minLength="8"
                  maxLength="128"
                />
                <button
                  className="btn btn-outline-secondary"
                  type="button"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  style={{ width: '50px', height: '38px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                >
                  {showConfirmPassword ? (
                    <EyeFill color="#000" />
                  ) : (
                    <EyeSlashFill color="#000" />
                  )}
                </button>
                </div>
                {resetPasswordFormik.touched.confirmPassword && resetPasswordFormik.errors.confirmPassword && (
                  <small id="confirmPasswordHelpBlock" className="form-text text-danger">
                    {resetPasswordFormik.errors.confirmPassword}
                  </small>
                )}
              </div>
              <div className="d-grid">
                <button type="submit" className="btn btn-success" disabled={isSubmitting}>
                  {isSubmitting ? (
                    <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    <span className="sr-only">Resetting...</span></>
                  ) : (
                    "Reset Password"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword; 